import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import connectApi from '../../api/connectApi'
import { constants } from '../../helpers'
import { RankingInterface, RankingPayloadType } from '../../storeTypes'
import { ErrorResponse } from '../../types'

export const veRankingAction = createAsyncThunk<
    [],
    RankingInterface,
    { rejectValue: string }
>('ranking/veRankingAction', async ({ zoneCode }, { rejectWithValue }) => {
    const { VES } = constants.endpoints
    try {
        const { data } = await connectApi.get(VES, {
            params: {
                zone_code: zoneCode
            }
        })
        return data
    } catch (error: unknown) {
        if (error instanceof ErrorResponse) {
            return rejectWithValue(error.response.data.detail)
        } else {
            return rejectWithValue('something went wrong')
        }
    }
})

const initialState: RankingPayloadType = {
    veRankingData: [],
    loading: false,
    error: '',
    preFetchLoading: false
}

export const rankingSlice = createSlice({
    name: 'ranking',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(veRankingAction.pending, (state) => {
                state.loading = true
                state.preFetchLoading = false
                state.error = ''
                state.veRankingData = []
            })
            .addCase(veRankingAction.fulfilled, (state, action) => {
                state.loading = false
                state.veRankingData = action.payload
                state.error = ''
            })
            .addCase(veRankingAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
                state.veRankingData = []
            })
    }
})

export default rankingSlice.reducer
